export default {
  value: 'סכום',
  type: 'סוג',
  date: 'תאריך',
  title: 'צפייה בחיובים של הסוכן {1}',
  addExpense: 'הוסף חיוב',
  modalTitle: 'צפייה בחיוב',
  archive: 'צפייה בארכיון',
  fileTitle: 'חיובים של הסוכן {1}',
  headers: {
    expenses: 'קיזוזים',
  },
};
